export default __webpack_public_path__ + "static/media/blue_pawn.da3f03d4.png";